import { render, staticRenderFns } from "./ExpZS97.vue?vue&type=template&id=a998096a&scoped=true&"
import script from "./ExpZS97.vue?vue&type=script&lang=js&"
export * from "./ExpZS97.vue?vue&type=script&lang=js&"
import style0 from "./ExpZS97.vue?vue&type=style&index=0&id=a998096a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a998096a",
  null
  
)

export default component.exports